import { render, staticRenderFns } from "./interestpayouts.vue?vue&type=template&id=073312ae"
import script from "./interestpayouts.vue?vue&type=script&lang=js"
export * from "./interestpayouts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports